import { validateCustomerInformation } from 'checkouts/customer_information';
import { validateBillingAddress } from 'checkouts/billing_address';

$(() => {
  const $form = $('#customer-details-form');
  if ($form.length > 0) {
    const $button = $form.find('.js-customer-details-button');
    const buttonLabel = $button.html();

    $form.on('submit', (e) => {
      const validCustomerInfo = validateCustomerInformation();
      const validAddress = validateBillingAddress();

      if (validCustomerInfo && validAddress) {
        $button.prop('disabled', true).html('Processing...');
      } else {
        e.preventDefault();
      }
    });

    // Back from the sign step restores this page from the bfcache with the button still disabled.
    $(window).on('pageshow', (e) => {
      if (e.originalEvent.persisted) {
        $button.prop('disabled', false).html(buttonLabel);
      }
    });
  }
});
